import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";

export const BannerWrapper = styled.div`
    position: relative;
    margin-left: ${'-' + globalStyles.desktop.pageMargin};
    margin-right: ${'-' + globalStyles.desktop.pageMargin};
    overflow: hidden;
    box-sizing: border-box;

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        margin-left: ${'-' + globalStyles.mobile.pageMargin};
        margin-right: ${'-' + globalStyles.mobile.pageMargin};
    }
`

export const BannerImg = styled.img`
    width: 100%;
`

export const ContentWrapper = styled.div`
    box-sizing: border-box;
    position: absolute;
    top: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 50%;
    color: white;
    padding: 0 ${globalStyles.desktop.pageMargin};
    background: rgb(2,0,36);
    background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.5) 80%, rgba(0,0,0,0) 100%);

    @media only screen and (max-width: ${globalStyles.breakpoints.large}) {
        width: 100%;
        padding: 0 ${globalStyles.desktop.pageMargin};
        text-align: center;
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.medium}) {
        padding: 0 ${globalStyles.desktop.pageMargin};
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        font-size: 0.7rem;
        padding: 0 ${globalStyles.mobile.pageMargin};
    }
`

export const Heading = styled.h1``

export const Content = styled.p``